import QuestionPickerItem from "./QuestionPickerItem";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { useAppSelector } from "../../../Redux/hooks";
import { useEffect, useState } from "react";
import { getQuestionTypes } from "../questionTypes";

const QBPickerWrapper = styled("div")({
  width: "278px",
  height: "100%",

  borderRadius: "8px",
  backgroundColor: "#ffffff",
  padding: "16px",
  overflowY: "hidden",
  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",

  "&:hover": {
    overflow: "auto",
  },
});

const QuestionPicker = () => {
  const formType = useAppSelector((state) => state.question.formCategory);
  const [questionTypes, setQuestionTypes] = useState<any[]>([]);

  useEffect(() => {
    if (formType) {
      setQuestionTypes(getQuestionTypes(formType));
    }
  }, [formType]);

  return (
    <QBPickerWrapper>
      <Typography color="text.primary" variant="h3" sx={{ mb: 0.5 }}>
        Select question type
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
        Select new question types to the left. Edit or rearrange them after.
      </Typography>
      <div>
        {questionTypes.map((questionType) => (
          <QuestionPickerItem
            key={questionType.key}
            questionType={questionType}
          />
        ))}
      </div>
    </QBPickerWrapper>
  );
};

export default QuestionPicker;
